import { render } from "./CharacterDetail.vue?vue&type=template&id=617b047a"
import script from "./CharacterDetail.vue?vue&type=script&lang=ts"
export * from "./CharacterDetail.vue?vue&type=script&lang=ts"

import "./CharacterDetail.vue?vue&type=style&index=0&id=617b047a&lang=scss"
script.render = render

export default script